import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Modal from "../../../../shared/modal/modal";
import Button from "../../../ui-kit/button/button";
import succesIcon from "../../../../images/success.svg";
import styles from "./submission-success-modal.module.scss";

interface SubmissionSuccessModalProps {
  onClose: () => void;
}

const SubmissionSuccessModal: FC<SubmissionSuccessModalProps> = ({
  onClose,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleDone = () => {
    onClose();
    navigate("/repository/utilities");
  };

  return (
    <Modal closeOnOverlayClick onClose={handleDone}>
      <div className={styles.submissionSuccessModal}>
        <h1 className={styles.title}>{t("submissionSuccessModal.title")}</h1>
        <img
          className={styles.image}
          src={succesIcon}
          alt={t("submissionSuccessModal.message")}
        />
        <span className={styles.message}>
          {t("submissionSuccessModal.message")}
        </span>
        <div className={styles.groupBtn}>
          <Button type="primary" className={styles.btn} onClick={handleDone}>
            {t("submissionSuccessModal.done")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SubmissionSuccessModal;